import { axiosClient, axiosSSOConfigPrivate } from '../../rest-client';
import { API_SEARCH_USERS_URL } from './urls';

export const searchUsersAndInvitations = async (params, headers) =>
  axiosClient.post(API_SEARCH_USERS_URL, params, axiosSSOConfigPrivate(headers));
